/* Globo supplies catalog results; the existing Liquid cards and CSS remain the renderer. */
(() => {
  const parameters = {
    'filter.p.m.custom.tcg_set': 853633,
    'filter.p.m.custom.tcg_card_kind_ref': 853634,
    'filter.p.m.custom.tcg_rarity_refs': 853635,
    'filter.p.m.custom.tcg_rarity_ref': 853636,
    'filter.v.availability': 853637,
    'filter.p.product_type': 853638
  };
  const expansionKey = 'filter.p.m.custom.tcg_set';
  const typeKey = 'filter.p.product_type';
  const rarityKey = 'filter.p.m.custom.tcg_rarity_refs';
  const legacyRarityKey = 'filter.p.m.custom.tcg_rarity_ref';
  const kindKey = 'filter.p.m.custom.tcg_card_kind_ref';
  const parser = new DOMParser();
  const cleanText = value => {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = String(value ?? '');
    return textarea.value;
  };
  const jsonRequest = async (url, signal) => {
    const response = await fetch(url, {signal});
    if (!response.ok) throw new Error('Catalog request failed: ' + response.status);
    const result = await response.json();
    if (result.processing || !Array.isArray(result.products) || !result.pagination) throw new Error('Catalog is synchronizing');
    return result;
  };
  document.querySelectorAll('[data-tcg-globo-config]').forEach(async script => {
    const root = document.getElementById(script.dataset.root);
    const form = root?.querySelector('.jt-filters');
    const grid = root?.querySelector('.jt-grid');
    if (!root || !form || !grid || root.dataset.globoStarted) return;
    root.dataset.globoStarted = 'true';
    const config = JSON.parse(script.textContent);
    const singles = config.mode === 'singles';
    const original = new URL(location.href);
    const query = original.searchParams;
    // Shopify may canonicalize repeated native filter parameters into a comma-separated value.
    for (const key of Object.keys(parameters)) {
      const values=query.getAll(key).flatMap(value=>value.split(','));
      if(values.length){query.delete(key);values.forEach(value=>query.append(key,value));}
    }
    const select = root.querySelector('[data-tcg-expansion]');
    const actions = form.querySelector('.jt-filter-actions');
    const reference = {...config.references};
    const baselineLabels = new Map();
    form.querySelectorAll('input[type="checkbox"]').forEach(input => {
      const span = input.closest('label')?.querySelector('span');
      if (span) {
        const clone = span.cloneNode(true);
        clone.querySelectorAll('small').forEach(small => small.remove());
        baselineLabels.set(input.name + '|' + input.value, clone.textContent.trim());
        if (input.value.startsWith('gid://') && !reference[input.value]) reference[input.value] = clone.textContent.trim();
      }
    });
    const refreshReferences = () => Array.from(select?.options || []).forEach(option => {
      if (option.dataset.globoValue) reference[option.value] = option.dataset.globoValue;
    });
    refreshReferences();
    const requestedSet = query.get(expansionKey) || config.set;
    const ensureExpansion = async signal => {
      if (!requestedSet || reference[requestedSet] || !requestedSet.startsWith('gid://')) return;
      let url = preservePreview(new URL(original.pathname, location.origin));
      url.searchParams.set('section_id','ji-tcg-extension-options');
      const visited = new Set();
      while (url && !visited.has(url.href)) {
        visited.add(url.href);
        const response = await fetch(url,{credentials:'same-origin',signal});
        if (!response.ok) throw new Error('Expansion directory unavailable');
        const html = parser.parseFromString(await response.text(),'text/html');
        const index = html.querySelector('[data-tcg-index]');
        if (!index || index.dataset.game !== config.game) throw new Error('Incorrect expansion directory');
        const options = [...index.querySelectorAll('option')];
        options.forEach(option => { if(option.dataset.globoValue) reference[option.value]=option.dataset.globoValue; });
        const found = options.find(option => option.value === requestedSet);
        if (found) {
          const option=found.cloneNode(true);
          const group=[...select.querySelectorAll('optgroup')].find(group => group.label===found.dataset.game?.replace('Cardass','Carddass'));
          option.dataset.base=group?.querySelector('option[data-base]')?.dataset.base || select.dataset.base;
          (group || select).append(option); select.value=requestedSet;
          if (!root.querySelector('.jt-active-expansion')) {
            const chip=document.createElement('p');chip.className='jt-active-expansion';
            const link=document.createElement('a');const reset=new URL(original);reset.searchParams.delete(expansionKey);reset.searchParams.delete('page');reset.searchParams.delete('tcg_page');
            link.href=reset.href;link.setAttribute('aria-label','Remove expansion filter');link.textContent='Extension: '+option.textContent.trim()+' ';
            const close=document.createElement('span');close.setAttribute('aria-hidden','true');close.textContent='×';link.append(close);chip.append(link);select.closest('.jt-navigation').after(chip);
          }
          return;
        }
        const next=index.querySelector('[data-tcg-index-next]');
        url=next ? preservePreview(new URL(next.getAttribute('href'),url)) : null;
        if(url) url.searchParams.set('section_id','ji-tcg-extension-options');
      }
      throw new Error('Expansion not found');
    };
    const sort = query.get('sort_by') || config.sort;
    const page = Math.max(1, parseInt(query.get('tcg_page') || query.get('page') || '1', 10) || 1);
    const preservePreview = url => {
      for (const key of ['preview_theme_id', 'pb', '_ab', '_fd', '_sc']) if (query.has(key)) url.searchParams.set(key, query.get(key));
      if (window.Shopify?.theme?.role === 'unpublished') url.searchParams.set('preview_theme_id', window.Shopify.theme.id);
      // Shopify's preview redirect collapses repeated filter parameters. The existing preview cookie keeps this theme selected.
      if ([...url.searchParams.keys()].some(key => url.searchParams.getAll(key).length > 1)) url.searchParams.delete('preview_theme_id');
      return url;
    };
    const selected = key => {
      const values = query.getAll(key);
      if (key === expansionKey && !values.length && config.set) values.push(config.set);
      return values.map(value => reference[value] || value);
    };
    const updateNavigation = () => {
      const types = query.getAll(typeKey);
      const knownTypes = ['Single Card — Promo','Promo Pack','Booster Box','Booster Pack','Sealed Deck','Sealed Collection','Card Collection Set'];
      const activeTypes = types.filter(type => knownTypes.includes(type));
      root.querySelectorAll('.jt-formats a').forEach(link => {
        const url = new URL(link.href);
        const linkTypes = url.searchParams.getAll(typeKey);
        let active = false;
        if (linkTypes.length) active = activeTypes.some(type => linkTypes.includes(type));
        else if (url.pathname.endsWith('/' + config.singleHandle)) active = singles && !activeTypes.length;
        else if (url.pathname.split('/collections/')[1] === original.pathname.split('/collections/')[1]) active = !singles && !activeTypes.length && !requestedSet;
        link.classList.toggle('jt-selected', active);
        if (active) link.setAttribute('aria-current','page'); else link.removeAttribute('aria-current');
      });
      root.querySelectorAll('a[href]').forEach(link => {
        const url=new URL(link.href);
        if(url.origin===location.origin) link.href=preservePreview(url).href;
      });
    };
    const productHandle = card => {
      const link = card.querySelector('a[href*="/products/"]');
      return link ? new URL(link.href).pathname.split('/products/')[1]?.split('/')[0] : null;
    };
    const setHidden = (key, values) => {
      form.querySelectorAll('input[type="hidden"]').forEach(input => { if (input.name === key) input.remove(); });
      for (const value of values) {
        const input = document.createElement('input');
        input.type = 'hidden'; input.name = key; input.value = value; form.append(input);
      }
    };
    // Keep existing URLs/bookmarks while letting Globo handle every facet and page.
    form.addEventListener('submit', event => {
      if (root.dataset.catalogEngine !== 'globo') return;
      event.preventDefault();
      const url = new URL(form.action);
      for (const [key, value] of new FormData(form)) if (String(value)) url.searchParams.append(key, String(value));
      location.assign(preservePreview(url).href);
    });
    const renderFilters = result => {
      const facets = new Map((result.filters || []).map(filter => [Number(filter.id), filter]));
      const rarity = query.has(legacyRarityKey) ? legacyRarityKey : rarityKey;
      const showLeader = ['dragon-ball-fusion-world-single-cards', 'one-piece-single-cards', 'dragon-ball-single-cards'].includes(config.singleHandle);
      const allowedKinds = ['gid://shopify/Metaobject/621536116990', 'gid://shopify/Metaobject/621536149758', ...(showLeader ? ['gid://shopify/Metaobject/621536772350'] : [])].map(id => reference[id]).filter(Boolean);
      const currentTypes = query.getAll(typeKey);
      const hideFormat = singles || currentTypes.some(type => ['Single Card — Promo', 'Promo Pack', 'Booster Box', 'Booster Pack', 'Sealed Deck', 'Sealed Collection', 'Card Collection Set'].includes(type));
      const keys = ['filter.v.availability', ...(!hideFormat ? [typeKey] : []), ...(singles ? [kindKey, rarity] : [])];
      const fragment = document.createDocumentFragment();
      for (const key of keys) {
        const filter = facets.get(parameters[key]) || (key === 'filter.v.availability' ? {values:[]} : null);
        if (!filter) continue;
        const sourceValues = key === 'filter.v.availability'
          ? ['1','0'].map(raw => (filter.values || []).find(value => String(value.value) === raw) || {value:raw,label:raw === '1' ? 'In stock' : 'Out of stock',count:0})
          : (filter.values || []);
        const values = sourceValues.filter(value => key !== kindKey || allowedKinds.includes(cleanText(value.value)));
        if (!values.length) continue;
        const fieldset = document.createElement('fieldset');
        const legend = document.createElement('legend');
        legend.textContent = key === typeKey ? 'Format' : key === kindKey ? 'Card type' : key === rarity ? 'Rarity' : 'Availability';
        fieldset.append(legend);
        for (const value of values) {
          const raw = cleanText(value.value);
          const id = key.includes('custom.') ? (Object.keys(reference).find(id => reference[id] === raw) || raw) : raw;
          const label = document.createElement('label'); label.className = 'jt-chip';
          const input = document.createElement('input'); input.type = 'checkbox'; input.name = key; input.value = id;
          input.checked = selected(key).includes(raw); input.disabled = !input.checked && Number(value.count) === 0;
          const span = document.createElement('span');
          const fallback = key === 'filter.v.availability' ? (raw === '1' ? 'In stock' : 'Out of stock') : cleanText(value.label);
          span.append((baselineLabels.get(key + '|' + id) || fallback) + ' ');
          const count = document.createElement('small'); count.textContent = '(' + value.count + ')'; span.append(count);
          label.append(input, span); fieldset.append(label);
        }
        fragment.append(fieldset);
      }
      form.querySelectorAll('fieldset').forEach(fieldset => fieldset.remove());
      form.insertBefore(fragment, actions);
      if (requestedSet) setHidden(expansionKey, [requestedSet]);
      if (hideFormat) setHidden(typeKey, currentTypes);
      actions.querySelector('select').value = sort;
      const reset = new URL(form.action);
      if (requestedSet) reset.searchParams.set(expansionKey, requestedSet);
      if (hideFormat && !singles || currentTypes.includes('Single Card — Promo')) currentTypes.forEach(value => reset.searchParams.append(typeKey, value));
      actions.querySelector('a').href = preservePreview(reset).href;
    };
    const renderPagination = pagination => {
      let nav = root.querySelector('.jt-pagination');
      const last = Number(pagination.last_page) || 1;
      if (last <= 1) { nav?.remove(); return; }
      if (!nav) { nav = document.createElement('nav'); nav.className = 'jt-pagination'; nav.setAttribute('aria-label', 'Pagination'); grid.after(nav); }
      nav.replaceChildren();
      const part = (label, target, className) => {
        const span = document.createElement('span'); span.className = className;
        if (target) {
          const link = document.createElement('a'); link.textContent = label;
          const url = new URL(original); url.searchParams.delete('page'); url.searchParams.set('tcg_page', target); link.href = preservePreview(url).href; span.append(link);
        } else span.textContent = label;
        nav.append(span, ' ');
      };
      if (page > 1) part('« Previous', page - 1, 'prev');
      const pages = [...new Set([1, last, ...Array.from({length:5}, (_, index) => page + index - 2)])].filter(n => n >= 1 && n <= last).sort((a,b) => a-b);
      let previous = 0;
      for (const n of pages) { if (previous && n - previous > 1) part('…', null, 'deco'); part(String(n), n === page ? null : n, n === page ? 'page current' : 'page'); previous = n; }
      if (page < last) part('Next »', page + 1, 'next');
    };
    const fetchCards = async (products, signal) => {
      const handles = products.map(product => product.handle);
      const present = [...grid.children].map(productHandle).filter(Boolean);
      if (handles.length === present.length && handles.every((handle,index) => present[index] === handle)) return null;
      const chunks = [];
      for (let start=0; start<handles.length; start+=20) chunks.push(handles.slice(start,start+20));
      const batches = await Promise.all(chunks.map(async handles => {
        if (!handles.every(handle => /^[a-z0-9-]+$/.test(handle))) throw new Error('Invalid catalog handle');
        const url = preservePreview(new URL(config.searchUrl, location.origin));
        url.searchParams.set('q', ['ji-tcg', singles ? 'singles' : 'products', ...handles].join('|'));
        url.searchParams.set('section_id', 'ji-tcg-product-batch');
        const response = await fetch(url, {credentials:'same-origin', signal});
        if (!response.ok) throw new Error('Product rendering failed');
        const html = parser.parseFromString(await response.text(), 'text/html');
        const batch = html.querySelector('[data-tcg-product-batch]');
        if (!batch || handles.some(handle => ![...batch.children].some(card => productHandle(card) === handle))) throw new Error('Incomplete product rendering');
        return [...batch.children];
      }));
      return batches.flat();
    };
    const run = async () => {
      root.querySelector('[data-tcg-globo-error]')?.remove();
      root.setAttribute('aria-busy', 'true');
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 30000);
      try {
        refreshReferences();
        await ensureExpansion(controller.signal);
        for (const key of Object.keys(parameters)) for (const value of selected(key)) if (value.startsWith('gid://') && !reference[value]) throw new Error('Unknown card reference');
        const base = window.GloboEmbedFilterConfig?.api?.url || 'https://filter-x3.globo.io';
        const url = new URL('/api/apiFilter', base);
        const values = {shop:config.shop,filter_id:54662,collection:config.collection,event:'init',page_type:'collection',limit:40,page,sort_by:sort,country:config.country,currency:config.currency,locale:config.locale};
        Object.entries(values).forEach(([key,value]) => url.searchParams.set(key, value));
        for (const [key,id] of Object.entries(parameters)) for (const value of selected(key)) url.searchParams.append('filter[' + id + '][]', value);
        const result = await jsonRequest(url, controller.signal);
        const cards = await fetchCards(result.products, controller.signal);
        if (cards) {
          if (!cards.length) {
            const empty = document.createElement('p'); empty.className = 'jt-empty'; empty.append('No products match this selection. ');
            const all = document.createElement('a'); all.href = form.action; all.textContent = 'View all ' + (singles ? config.game + ' Unit Cards' : 'expansions'); empty.append(all, '.'); grid.replaceChildren(empty);
          } else grid.replaceChildren(...cards);
        }
        renderFilters(result);
        root.querySelector('.jt-count').textContent = result.pagination.total + ' products' + (requestedSet ? ' in this expansion' : '');
        renderPagination(result.pagination);
        updateNavigation();
        root.dataset.catalogEngine = 'globo';
        root.dispatchEvent(new CustomEvent('ji:catalog:rendered', {bubbles:true}));
      } catch (error) {
        console.error('[Jump Ichiban TCG]', error);
        root.dataset.catalogEngine = 'error';
        const message = document.createElement('p'); message.className = 'jt-intro'; message.dataset.tcgGloboError = '';
        message.setAttribute('role','status'); message.append('The latest catalog could not be loaded. ');
        const retry = document.createElement('button'); retry.type='button'; retry.textContent='Try again'; retry.addEventListener('click',run); message.append(retry); form.after(message);
      } finally {clearTimeout(timeout);root.removeAttribute('aria-busy');}
    };
    await run();
  });
})();

